const imagesArray = [
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0094.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0095.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0096.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0097.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0098.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0099.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0100.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0101.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0102.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0103.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0104.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0105.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0106.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0107.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0108.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0109.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0110.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0111.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0112.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0113.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0114.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0115.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0116.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0117.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0118.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0119.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0120.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0121.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0122.png.jpg"),
  require("../assets/sprites-interior/LS_3DSprite_Vitra02.0123.png.jpg")
]

export {
  imagesArray
};

